import React, {useEffect, useState} from 'react';
import {useSelector} from "react-redux";
import {Col, Container, Row} from "react-bootstrap";

import {config} from "../../../Config";

import {service as LibraryService} from "../../../Services/LibraryService";

import {DocumentUtils, ObjectUtils} from "../../../Utils";

import {useCheckAuth} from "../../../Hooks/RouteHooks";

import {StreamBankPageHeader} from "../../Common/StreamBankPageHeader";

export const LibraryRedirectPage = props => {
    useCheckAuth();
    const user = useSelector(state => state.userState.user);
    const [redirected, setRedirected] = useState(false);

    useEffect(() => {
        if(user?.userId && !user.twoFactorRequired) {
            attemptRedirect(user.username)
        }
    }, [user?.userId, user?.username, user?.twoFactorRequired]);

    const attemptRedirect = (email) => {
        const url = DocumentUtils.GetQueryStringParameter("bookstackUrl") || '/';

        if(!redirected) {
            LibraryService.SetAuthToken(email)
                .then(x => {
                    const authToken = x.result.authToken;
                    const queryString = ObjectUtils.BuildQueryString({
                        'token': authToken,
                        'redirect': url,
                    });

                    setRedirected(true);

                    window.location.replace(config.getUrl('library') + '/authorize?' + queryString);
                })
                .catch(x => {
                    if(x.data && x.data.message) {
                        alert(x.data.message);
                    } else {
                        alert(x.message || "Auth token could not be updated.");
                    }
                })
        }
    };

    return <Container className={"sb-root-page sb-redirect-page"}>
        <StreamBankPageHeader
            Title={"Redirecting"}
        />
        <Row key={1}>
            <Col xs={12} md={12}>
                <h2>Redirecting to Library, please wait a moment.</h2>
            </Col>
        </Row>
    </Container>;
}


